<k2-select
  [value]="place.country"
  (valueChange)="changeCountry($event)"
  [options]="countries"
  placeholder="Select country..."
  [disabled]="disabled"
></k2-select>

@if (states != null) {
<k2-select
  [value]="place.state"
  (valueChange)="changeState($event)"
  [options]="states"
  placeholder="Select state..."
  [disabled]="disabled"
  class="state"
></k2-select>
}
